import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import { useWindowWidth } from '@react-hook/window-size/throttled';

import Icon from 'components/ui/Icon';
import CardRelatedArticles from './components/CardRelatedArticles';
import { Button } from 'components/ui/Button';

import useRandom from 'hooks/graphql/useRandom';
import useOptions from 'hooks/graphql/useOptions';

import { viewMore } from './styles.module.scss';

const RelatedArticles = ({
  data,
  currntPostId = '',
  bgColor = 'bg-merino',
}) => {
  const windowWidth = useWindowWidth({ initialWidth: 640 });
  const randomArticles = useRandom({
    arrToFilter: data,
    currentId: currntPostId,
    countToDisplay: 3,
  });
  const options = useOptions();

  const {
    general: {
      relatedArticles: { relatedArticlesViewAllButton },
    },
  } = options.general;

  return (
    <>
      {randomArticles.length > 0 ? (
        <section
          className={classnames('pt-16 pb-16 lg:pt-20 lg:pb-28 ', bgColor)}
        >
          <div className="fluid-container">
            <div className="mb-8 sm:mb-10 sm:flex sm:justify-between">
              <p className="oc-subtitle uppercase">related articles</p>

              {windowWidth > 640 ? (
                <Link
                  to={relatedArticlesViewAllButton.url}
                  className={classnames(
                    viewMore,
                    'oc-base uppercase flex items-center ',
                  )}
                >
                  {relatedArticlesViewAllButton.title}
                  <Icon name="arrow-right" className="ml-3 h-9 w-9 m-auto" />
                </Link>
              ) : null}
            </div>

            <ul className="sm:flex sm:justify-between sm:items-stretch sm:flex-wrap sm:-mx-2.5">
              {randomArticles.map((card, i) => (
                <li
                  key={i}
                  className="mb-5 sm:flex-2 sm:px-2.5 lg:flex-3 lg:mb-0"
                >
                  <CardRelatedArticles data={card} />
                </li>
              ))}
            </ul>

            {windowWidth <= 640 ? (
              <Button href={'#'} className={'mt-5 btn--fill w-full'}>
                More articles
              </Button>
            ) : null}
          </div>
        </section>
      ) : null}
    </>
  );
};

export default RelatedArticles;
